export default "<div>{{ GetStatutEvacuation(status) }}</div>";